import { Routes } from '../../../../routes';
import { getUserProfile, updateProfile } from '../api';

import { removeData, storeUserData } from '../utils';

const removeToken = (data) => {
  // Store token
  removeData('sjwt');
  removeData('suser');
};

const services = (dispatch, actions) => ({
  getUserProfile: async (payload) => {
    dispatch(actions.loadingUserData(true));
    await getUserProfile(payload)
      .then((res) => {
        storeUserData(res.data);

        dispatch(actions.getUserData(res));
      })
      .catch((error) => {
        // failed
        if (error.response) {
          if (error.response?.data?.statusCode === 401) {
            removeToken();
            window.location.href = `${Routes.LoginPage}?r=${window.location.href.replace(
              window.location.origin,
              ''
            )}`;
            return;
          }
          dispatch(
            actions.tokenError({
              message: error.response.data.message,
              status: error.response.data.statusCode,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },

  updateProfile: async (payload) => {
    // get the login user
    if (!payload.id) {
      dispatch(
        actions.tokenError({
          message: 'User id is required',
          status: '400',
        })
      );
    }

    await updateProfile(payload)
      .then((res) => {
        storeUserData(res.data);
        dispatch(actions.profileUpdate(res));
      })
      .catch((error) => {
        // failed
        if (error.response) {
          if (error.response?.data?.statusCode === 401) removeToken();
          dispatch(
            actions.tokenError({
              message: error.response.data.message,
              status: error.response.data.statusCode,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },

  updatePassword: async (payload) => {
    // get the login user
    if (!payload.id) {
      dispatch(
        actions.tokenError({
          message: 'User id is required',
          status: '400',
        })
      );
    }

    await updateProfile(payload)
      .then((res) => {
        dispatch(actions.passwordUpdate(res));
      })
      .catch((error) => {
        // failed
        if (error.response) {
          if (error.response?.data?.statusCode === 401) removeToken();
          dispatch(
            actions.tokenError({
              message: error.response.data.message,
              status: error.response.data.statusCode,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },
  updateMessage: async (payload) => {
    dispatch(actions.updateMessage(payload));
  },
  resetMessage: async (payload) => {
    dispatch(actions.resetMessage(payload));
  },
});

export default services;
